import { Chart, Interaction } from "chart.js";
import { CrosshairPlugin, Interpolate } from "chartjs-plugin-crosshair";

Interaction.modes.interpolate = Interpolate;

/**
 * @property { Chart } chart
 */
class LineChart {
    #OPTIONS = {
        type: "line",
        data: {
            labels: [],
            datasets: [],
        },
        plugins: [CrosshairPlugin],
        options: {
            maintainAspectRatio: false,
            responsive: false,
            elements: {
                point: {
                    pointStyle: "circle",
                    radius: 0.5,
                    borderWidth: 0,
                    hoverBorderWidth: 0,
                    hitRadius: 15,
                },
                line: {
                    showLine: false,
                    fill: true,
                    borderWidth: 0,
                },
            },
            scales: {
                y: {
                    display: false,
                    beginAtZero: true,
                },
                x: {
                    grid: {
                        display: false,
                        borderWidth: 1,
                    },
                    ticks: {
                        display: true,
                        padding: 10,
                        font: {
                            size: 10,
                            family: "iranyekanfanum",
                            weight: 500,
                        },
                    },
                },
            },
            plugins: {
                tooltip: {
                    rtl: true,
                    textDirection: "rtl",
                    mode: "interpolate",
                    intersect: false,
                    titleFont: {
                        family: "iranyekanfanum",
                        weight: "bold",
                    },
                    bodyFont: {
                        family: "iranyekanfanum",
                    },
                },
                legend: {
                    display: false,
                },
                crosshair: {
                    line: {
                        color: "#1BAD6A",
                        width: 1,
                        dashPattern: [5, 3],
                    },
                    sync: {
                        enabled: false,
                    },
                    zoom: {
                        enabled: false,
                    },
                    snap: {
                        enabled: false,
                    },
                },
            },
        },
    };

    chart;

    /**
     * Creates a chart.js stacked chart
     * @param {string} selector chart element selector
     */
    constructor(selector) {
        const chart_elm = document.querySelector(selector);
        this.chart = new Chart(chart_elm, this.#OPTIONS);
    }
}

export { LineChart };
